<div class="container">
  <p class="content" [innerHTML]="data.content"></p>
</div>
